import React from 'react';

const pilaresConfianza = [
  {
    id: 1,
    titulo: 'Trato Directo y Cercano',
    descripcion: 'Sin conmutadores ni comisiones infladas de apps. Hablas directamente por WhatsApp con quien te atiende y resuelve tus dudas.',
    icon: 'fa-comments'
  },
  {
    id: 2,
    titulo: 'Alojamientos Verificados',
    descripcion: 'Conocemos personalmente cada casa y departamento en Huatulco. Fotos reales, limpias y listas para tu llegada.',
    icon: 'fa-house-circle-check'
  },
  {
    id: 3,
    titulo: 'Recomendaciones Locales',
    descripcion: 'Consejos sinceros sobre las mejores bahías, restaurantes típicos y opciones de transporte para disfrutar la costa oaxaqueña.',
    icon: 'fa-map-location-dot'
  },
  {
    id: 4,
    titulo: 'Coordinación de Llegada',
    descripcion: 'Te acompañamos en el proceso de check-in, enlazándote puntualmente con los encargados de la propiedad.',
    icon: 'fa-handshake-angle'
  }
];

const testimoniosHuespedes = [
  {
    id: 1,
    autor: 'Sofía R.',
    origen: 'Ciudad de México',
    estancia: 'Loft 222 · Punta Gaviota',
    texto: 'Atención impecable desde el primer mensaje de WhatsApp. Nos ayudó a elegir la mejor opción para nuestras fechas y nos recomendó playas tranquilas poco concurridas. Todo transparente y confiable.',
    iniciales: 'SR'
  },
  {
    id: 2,
    autor: 'Familia Mendoza',
    origen: 'Puebla',
    estancia: 'Casa La Primavera',
    texto: 'Viajábamos un grupo grande y teníamos dudas sobre la distribución de las recámaras. Nos explicó todo a detalle con mucha paciencia. Al llegar la casa estaba impecable y la coordinación fue excelente.',
    iniciales: 'FM'
  },
  {
    id: 3,
    autor: 'Mariana & David',
    origen: 'Guadalajara',
    estancia: 'Departamento Costa',
    texto: 'Mucho mejor que lidiar con plataformas automáticas. Se agradece hablar con una persona que de verdad conoce el lugar y responde pronto. Sin duda volveremos a contactarla en nuestro próximo viaje a Huatulco.',
    iniciales: 'MD'
  }
];

function TestimonialsSection() {
  return (
    <section className="testimonials-section" id="testimonios">
      <div className="section-container">
        
        {/* Pilares de servicio */}
        <div className="section-intro">
          <span className="section-eyebrow">
            <i className="fas fa-heart text-terracotta"></i> Por qué reservar por este medio
          </span>
          <h2 className="section-heading">La tranquilidad de un trato humano</h2>
          <p className="section-desc">
            Rentar para tus vacaciones no tiene por qué ser frío ni complicado. Te brindo acompañamiento honesto y comunicación constante.
          </p>
        </div>

        <div className="pillars-grid">
          {pilaresConfianza.map((pilar) => (
            <div key={pilar.id} className="pillar-card">
              <div className="pillar-icon-box">
                <i className={`fas ${pilar.icon}`}></i>
              </div>
              <h3 className="pillar-title">{pilar.titulo}</h3>
              <p className="pillar-desc">{pilar.descripcion}</p>
            </div>
          ))}
        </div>

        {/* Opiniones de Huéspedes */}
        <div className="reviews-block">
          <div className="section-intro">
            <span className="section-eyebrow">Experiencias Reales</span>
            <h2 className="section-heading">Lo que comparten quienes nos visitan</h2>
            <p className="section-desc">
              Comentarios de viajeros que han confiado en nuestro enlace para sus días de descanso en Huatulco.
            </p>
          </div>

          <div className="reviews-grid">
            {testimoniosHuespedes.map((item) => (
              <div key={item.id} className="review-card">
                <div className="review-header">
                  <div className="review-stars">
                    <i className="fas fa-star"></i>
                    <i className="fas fa-star"></i>
                    <i className="fas fa-star"></i>
                    <i className="fas fa-star"></i>
                    <i className="fas fa-star"></i>
                  </div>
                  <span className="review-stay-tag">{item.estancia}</span>
                </div>
                <p className="review-text">"{item.texto}"</p>
                <div className="review-author-wrap">
                  <div className="review-avatar">{item.iniciales}</div>
                  <div className="review-meta">
                    <span className="review-name">{item.autor}</span>
                    <span className="review-origin">
                      <i className="fas fa-location-dot"></i> {item.origen}
                    </span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

      </div>
    </section>
  );
}

export default TestimonialsSection;
